import { action } from "../Data";
import moment from "moment";
import uuidv1 from "uuid/v1";

export const SERVICE_URL = "https://valid.mcheckplus.com";

export const COUNTRY_CODES = ["kr", "en", "cn"];

export const LOGIN_SUCCESS_MESSAGE = "로그인에 성공하였습니다!";
export const LOGIN_WARNING_MESSAGE = "아이디 또는 비밀번호를 확인해주세요.";
export const LOGOUT_SUCCESS_MESSAGE = "로그아웃에 성공하였습니다.";

// event //

export const MESSAGE_TABLE = {
  kr: {
    NOT_LOGIN: "로그인이 필요한 서비스입니다.",
    NOT_AUTHORIZED_ACCOUNT:
      "인증된 계정이 아닙니다. 로그인을 시도한 사이트에서 확인해주세요.",
    NOT_CORRECT_EMAIL: "이메일을 입력해주세요.",
    NOT_CORRECT_NAME: "이름을 입력해주세요.",
    NOT_CORRECT_YEAR: "연도를 입력해주세요.",
    NOT_CORRECT_ESEX: "성별을 선택해주세요.",

    CHECK_ID_ALERT: "아이디는 최소 6자 이상이어야 합니다.",
    CHECK_PWD_ALERT: "암호는 최소 6자 이상이어야 합니다.",

    CHECK_PRODUCT_COMPANY: "제휴사를 선택하세요.",
    CHECK_PRODUCT_IMAGES_KR:
      "한국 서비스 제품 이미지를 최소 1개 이상 등록해주세요.",
    CHECK_PRODUCT_IMAGES_EN:
      "영문 서비스 제품 이미지를 최소 1개 이상 등록해주세요.",
    CHECK_PRODUCT_IMAGES_CN:
      "중국 서비스 제품 이미지를 최소 1개 이상 등록해주세요.",

    CHECK_EVENT_COMPANY: "제휴사를 선택하세요.",
    CHECK_EVENT_PRODUCT: "제품을 선택하세요.",
    CHECK_PRODUCT_REGISTERED: "제품을 먼저 등록하세요.",
    COPY_TO_CLIPBOARD: "클립보드에 복사되었습니다.",

    CHECK_EVENT_IMAGE_KR: "한국 서비스의 이벤트 이미지를 등록해주세요.",
    CHECK_EVENT_IMAGE_EN: "영문 서비스의 이벤트 이미지를 등록해주세요.",
    CHECK_EVENT_IMAGE_CN: "중국 서비스의 이벤트 이미지를 등록해주세요.",
    CHECK_EVENT_PRIZE_INIT:
      "지정한 이벤트 상품 정보가 초기화됩니다. 계속하시겠습니까?",
    CHECK_EVENT_PRIZE_MINIMUM: "이벤트 상품은 최소 1개 이상 등록해야 합니다.",
    CHECK_EVENT_VALUE: "이벤트 상품에 필요한 값을 모두 입력해주세요.",
    CHECK_EVENT_CODE_AND_BARCODE:
      "프로모션 코드, 바코드는 둘 중에 하나만 입력 가능합니다.",
    CHECK_EVENT_PRIZE_PERCENT_OVER_100:
      "상품의 확률 합계를 100 이하로 지정해주세요.",
    CHECK_EVENT_REGISTERED: "이벤트를 먼저 등록하세요.",
    CHECK_ONLY_NUMBER: "숫자만 입력 가능합니다.",
    EVENT_CREATE_ERROR:
      "같은 제품에 이벤트 기간이 겹치는 다른 이벤트가 등록되어있습니다.",

    CHECK_PERSONAL_INFO_AGREE: "개인정보 제공에 동의해주세요.",

    EVENT_WRONG_ACCESS_MESSAGE: "잘못된 접근입니다.",
    EVENT_NOT_EXISTS: "이벤트를 찾을 수 없습니다.",
    EVENT_EXPIRED: "이벤트가 종료되었습니다.",

    FEED_NOT_CHECKED: "항목을 체크해주세요.",
    FEED_ETC_NOT_EXIST: "기타 항목을 입력해주세요.",
    FEED_SUBMITTED: "설문 제출이 완료되었습니다.",
    FEED_SUBMITTED2: "고객님의 소중한 의견 감사드립니다.",

    /////// 유통자 //////////
    TAKE_OVER_COMPLETE: "인수완료 되었습니다!",
    HAND_OVER_COMPLETE: "인계완료 되었습니다!",

    /////// 관리자 //////////
    PRODUCT_IMAGE_LIMIT_EXCEED: "이미지는 최대 10개까지 등록 가능합니다.",
    CONFIRM_SEND_MESSAGE: "메시지를 전송하시겠습니까?",

    ///// 관리자 추가된 항목들 ////
    CHECK_EA_RANGE: "수량을 0 ~ 1,000,000 사이로 입력해주세요.",
    CHECK_EA_ALERT:
      "하위 레벨의 코드발행 수량은 상위레벨의 수용 수량보다 많을 수 없습니다.",
    CODE_CREATE_PROCESSING: "코드를 발행하는 중입니다. 잠시후에 시도해주세요.",
    CODE_CREATE_COMPLETED: "코드발행이 완료 되었습니다.",
    ISSUE_CODE_FIRST: "발행된 코드가 없습니다. 코드를 먼저 발행해주세요.",
    PRODUCT_CODE_ORDER_LIMITTED:
      "제품 순번 코드는 0~99번까지만 지정이 가능합니다.",

    PRODUCT_CREATE_PROCESSING:
      "제품을 등록하는 중입니다. 잠시후에 시도해주세요.",
    PRODUCT_CREATE_COMPLETED: "제품이 등록 되었습니다.",
    URL_REQUIRED:
      "자석인증 안내가 ON상태입니다. 모든 국가에 연결될 URL을 입력해주세요.",

    EVENT_CREATE_COMPLETED: "이벤트가 등록 되었습니다.",
    NUMBER_ONLY: "확률/상품수량은 숫자만 입력이 가능합니다.",

    SELECT_DISTRIBUTOR_CODE: "코드를 선택해주세요.",
    SELECT_DISTRIBUTORS: "1명 이상의 유통자를 지정해주세요.",
    SELECT_DISTRIBUTORS_COMPLETED: "유통자 지정이 완료되었습니다.",
    SELECT_DISTRIBUTORS_REMOVED: "유통자가 삭제 되었습니다.",

    POST_CODE_LENGTH: "우편번호는 10글자 이내로 입력해주세요.",
    COMPANY_ID_LENGTH: "아이디를 5글자 이상으로 입력해주세요.",

    USER_DUPLICATED: "이미 등록된 이메일 입니다.",
    COMPANY_CREATE_COMPLETED: "제휴사가 등록 되었습니다.",
    DISTRIBUTOR_CREATE_COMPLETED: "유통자가 등록 되었습니다.",
    ADMIN_CREATE_COMPLETED: "관리자가 등록 되었습니다.",

    PARAM_ERROR: "필수값이 누락되었습니다.",
    INVALID_PARAM: "필수값이 누락되었습니다.",
    STATUS_UPDATED: "상태가 변경 되었습니다.",
    UPDATE_COMPLETED: "정보가 업데이트 되었습니다.",
    CREATE_COMPLETED: "정보가 저장 되었습니다.",
    ////////////

    UNKNOWN_ERROR: "알 수 없는 네트워크 에러입니다.",

    CONFIRM_OVER_10000: "인증가능 범위를 초과 했습니다.",
    ACTION_DUPLICATED:
      "이전에 요청한 인수인계 & 이동삭제 작업이 끝나지 않았습니다. 기다려주세요.",

    //MSG_ 로 시작하는 에러코드는 유저에게 이유를 출력해줘야 한다.
    MSG_MUST_DO_HANDOVER_FIRST: "아직 인계가 되지않은 제품/박스 코드입니다.", //아직 인계가 안된 제품/박스 CODE입니다.
    MSG_THIS_CODE_CAN_NOT_TAKE_OVER: "자신이 인수 가능한 코드가 아닙니다.", // 내가 인수 할 수있는 CODE가 아닙니다. 남의 소유.
    MSG_THIS_CODE_WAS_TAKE_OVER: "이미 인계된 코드입니다.", //벌써 인계된 코드입니다.
    MSG_CODE_IS_NOT_TAKE_OVER: "자신이 인수 하지않은 코드입니다.", //자신이 인수한 CODE가 아닙니다.
    MSG_CODE_IS_NOT_HAND_OVER: "자신이 인계 가능한 코드가 아닙니다.", //자신이 인계할 수 있는 CODE가 아닙니다.
    MSG_EXCEL_CODE_DATA_IS_INVALID: "올바른 형식의 엑셀파일이 아닙니다.", // 수동 업로드되는 엑셀파일 포맷에 오류가 있습니다.
    MSG_CODE_IS_NOT_MINE: "이 코드의 담당자가 아닙니다.", // 이 CODE의 담당자가 아닙니다.
    MSG_PRODUCT_CAN_NOT_CONFIRMED: "상품을 인증 할 수 없습니다.", // 상품을 인증할 수 없습니다.
    MSG_CODE_IS_NOT_TAKE_OVER1: "자신이 인수 가능한 코드가 아닙니다.",
    MSG_CODE_IS_NOT_HAND_OVER1:
      "QR코드의 제품 또는 회사종류가 동일하지 않습니다.",
    MSG_CODE_IS_NOT_HAND_OVER2: "동일회사의 제품이 아닙니다.",

    //서버에서 오는게 아닌 클라이언트에서 자체적으로 띄워주는 에러 메시지, MSG가 붙지 않는다 0916
    NO_PRODUCT_CODE_CONFIRMED: "비교할 승인 코드를 받아오지 않았습니다",
    INPUT_PRODUCT_CODE: "승인 코드를 입력해주세요.",
    NOT_PROVIDED_PRODUCT_CODE: "승인 코드가 일치하지 않습니다",

    // 로그인
    AUTHENTICATION_INVALID: "해당 계정은 사용이 중지된 계정입니다.",
    USER_MISMATCH: "아이디 혹은 비밀번호를 확인해주세요.",
    PASSWORD_MISMATCH: "잘못된 비밀번호 입니다."
  },
  en: {
    NOT_LOGIN: "Not Login",
    NOT_AUTHORIZED_ACCOUNT:
      "인증된 계정이 아닙니다. 해당 사이트에서 확인해주세요.",
    NOT_CORRECT_EMAIL: "Email is not correct.",
    NOT_CORRECT_NAME: "Please input your name.",
    NOT_CORRECT_YEAR: "Please input birth year.",
    NOT_CORRECT_ESEX: "Please select your gender.",

    CHECK_ID_ALERT: "Please enter your ID at least 6 characters.",
    CHECK_PWD_ALERT: "Please enter your password at least 6 characters.",

    CHECK_PRODUCT_COMPANY: "Please select company.",
    CHECK_PRODUCT_IMAGES_KR:
      "Please upload at least 1 image of product in Korean service.",
    CHECK_PRODUCT_IMAGES_EN:
      "Please upload at least 1 image of product in English service.",
    CHECK_PRODUCT_IMAGES_CN:
      "Please upload at least 1 image of product in Chinese service.",

    CHECK_EVENT_COMPANY: "Please select company.",
    CHECK_EVENT_PRODUCT: "Please select product.",
    CHECK_PRODUCT_REGISTERED: "Register your product first.",
    COPY_TO_CLIPBOARD: "Copied to Clipboard",

    CHECK_EVENT_IMAGE_KR: "Register event image of Korean service.",
    CHECK_EVENT_IMAGE_EN: "Register event image of English service.",
    CHECK_EVENT_IMAGE_CN: "Register event image of Chinese service.",
    CHECK_EVENT_PRIZE_INIT:
      "The specified event prize information is initialized. Do you still want to continue?",
    CHECK_EVENT_PRIZE_MINIMUM: "At least 1 event product must be registered.",
    CHECK_EVENT_VALUE: "Please input all required values for the event prize.",
    CHECK_EVENT_CODE_AND_BARCODE:
      "Only one of promotion code or barcode can be entered.",
    CHECK_EVENT_PRIZE_PERCENT_OVER_100:
      "Please specify the total percent of the product below 100.",
    CHECK_EVENT_REGISTERED: "이벤트를 먼저 등록하세요.",
    CHECK_ONLY_NUMBER: "숫자만 입력 가능합니다.",
    EVENT_CREATE_ERROR:
      "Another event is registered in the same product with overlapping event periods.",

    CHECK_PERSONAL_INFO_AGREE:
      "Please agree to offer your personal information",

    EVENT_WRONG_ACCESS_MESSAGE: "Wrong Access",
    EVENT_NOT_EXISTS: "No Event.",
    EVENT_EXPIRED: "This event is expired.",

    FEED_NOT_CHECKED: "Please select the answer.",
    FEED_ETC_NOT_EXIST: "Please input the answer.",
    FEED_SUBMITTED: "Your survey has been submitted",
    FEED_SUBMITTED2: "Thank you for your feedback.",

    /////// 유통자 //////////

    TAKE_OVER_COMPLETE: "Take-over is complete",
    HAND_OVER_COMPLETE: "Hand-over is complete",

    /////// 관리자 //////////
    PRODUCT_IMAGE_LIMIT_EXCEED: "Images can be registered up to 10.",
    CONFIRM_SEND_MESSAGE: "Are you sure you want to send the message?",

    ///// 관리자 추가된 항목들 ////
    CHECK_EA_RANGE: "Please enter a quantity between 0 and 1,000,000.",
    CHECK_EA_ALERT:
      "The quantity of code issued at the lower level cannot be greater than the quantity accepted at the upper level.",
    CODE_CREATE_PROCESSING: "Code is being issued Please try later.",
    CODE_CREATE_COMPLETED: "Code issuance is complete.",
    ISSUE_CODE_FIRST: "No code issued. Please issue the code first.",
    PRODUCT_CODE_ORDER_LIMITTED:
      "Product serial number can be assigned only from 0 to 99.",

    PRODUCT_CREATE_PROCESSING: "Registering your product. Please try later.",
    PRODUCT_CREATE_COMPLETED: "The product is registered.",
    URL_REQUIRED:
      "The magnet certification guide is ON. Please enter a URL to link to.",

    EVENT_CREATE_COMPLETED: "The event has been registered.",
    NUMBER_ONLY: "Probability / item quantity can be input only numbers.",

    SELECT_DISTRIBUTOR_CODE: "Please select a code",
    SELECT_DISTRIBUTORS: "Please specify at least one distributor.",
    SELECT_DISTRIBUTORS_COMPLETED: "Distributor assignment is complete.",
    SELECT_DISTRIBUTORS_REMOVED: "Distributor has been removed.",

    POST_CODE_LENGTH: "Please enter the postal code within 10 characters.",
    COMPANY_ID_LENGTH: "Please enter at least 5 characters.",

    USER_DUPLICATED: "This email is already registered.",
    COMPANY_CREATE_COMPLETED: "Company has been registered.",
    DISTRIBUTOR_CREATE_COMPLETED: "Distributor has been registered.",
    ADMIN_CREATE_COMPLETED: "The administrator is registered.",

    PARAM_ERROR: "Required value is missing.",
    INVALID_PARAM: "Required value is missing.",
    STATUS_UPDATED: "The state has changed.",
    UPDATE_COMPLETED: "The information has been updated.",
    CREATE_COMPLETED: "The information has been saved.",
    ////////////

    UNKNOWN_ERROR: "Network Error.",

    CONFIRM_OVER_10000: "Exceeded certification range.",
    ACTION_DUPLICATED:
      "The previously requested takeover & delete operation has not been completed. Please wait.",

    //MSG_ 로 시작하는 에러코드는 유저에게 이유를 출력해줘야 한다.
    MSG_MUST_DO_HANDOVER_FIRST:
      "This product / box code has not yet been handed over.", //아직 인계가 안된 제품/박스 CODE입니다.
    MSG_THIS_CODE_CAN_NOT_TAKE_OVER:
      "It is not your own code that can be acquired.", // 내가 인수 할 수있는 CODE가 아닙니다. 남의 소유.
    MSG_THIS_CODE_WAS_TAKE_OVER: "Code is already taken over", //벌써 인계된 코드입니다.
    MSG_CODE_IS_NOT_TAKE_OVER: "Code that you did not take.", //자신이 인수한 CODE가 아닙니다.
    MSG_CODE_IS_NOT_HAND_OVER: "It is not a code that you can take over.", //자신이 인계할 수 있는 CODE가 아닙니다.
    MSG_EXCEL_CODE_DATA_IS_INVALID: "It is not a well-formed Excel file.", // 수동 업로드되는 엑셀파일 포맷에 오류가 있습니다.
    MSG_CODE_IS_NOT_MINE: "You are not in charge of this code.", // 이 CODE의 담당자가 아닙니다.
    MSG_PRODUCT_CAN_NOT_CONFIRMED: "The item cannot be authenticated.", // 상품을 인증할 수 없습니다.
    MSG_CODE_IS_NOT_TAKE_OVER1: "It is not your own code that can be acquired.",
    MSG_CODE_IS_NOT_HAND_OVER1:
      "The QR code product or company type is not the same.",
    MSG_CODE_IS_NOT_HAND_OVER2: "It is not a product of the same company.",

    //서버에서 오는게 아닌 클라이언트에서 자체적으로 띄워주는 에러 메시지, MSG가 붙지 않는다 0916
    NO_PRODUCT_CODE_CONFIRMED:
      "You have not received an authorization code to compare.",
    INPUT_PRODUCT_CODE: "Please enter the authorization code.",
    NOT_PROVIDED_PRODUCT_CODE: "Authorization codes do not match",

    // 로그인
    AUTHENTICATION_INVALID: "This account is disabled.",
    USER_MISMATCH: "아이디 혹은 비밀번호를 확인해주세요.",
    PASSWORD_MISMATCH: "잘못된 비밀번호 입니다."
  },
  cn: {
    NOT_LOGIN: "Not Login China",
    NOT_AUTHORIZED_ACCOUNT: "这个帐号没有授权。 请检查您登录的网站",
    NOT_CORRECT_EMAIL: "Email is not correct China",
    NOT_CORRECT_NAME: "Please input your name China",
    NOT_CORRECT_YEAR: "Please input your birth year China",
    NOT_CORRECT_ESEX: "Please select your gender China",

    CHECK_ID_ALERT: "用户名至少要6字以上。",
    CHECK_PWD_ALERT: "密码至少要在6字以上。",

    CHECK_PRODUCT_COMPANY: "请选择合作公司。",
    CHECK_PRODUCT_IMAGES_KR: "请在韩国服务至少1次以上产品。",
    CHECK_PRODUCT_IMAGES_EN: "请在英文服务中至少载入至少1张产品。。",
    CHECK_PRODUCT_IMAGES_CN: "请至少载入中国服务公司的1个产品。。",

    CHECK_EVENT_IMAGE_KR: "请登记韩国服务的活动图片。",
    CHECK_EVENT_IMAGE_EN: "请登记英文服务活动图片。",
    CHECK_EVENT_IMAGE_CN: "请注册中国服务活动图片。",
    CHECK_EVENT_PRIZE_INIT: "指定活动商品信息初始化。 要继续吗？",
    CHECK_EVENT_PRIZE_MINIMUM: "活动商品至少要登记1个以上。",
    CHECK_EVENT_VALUE: "请输入活动商品所需价格。",
    CHECK_EVENT_CODE_AND_BARCODE: "只能输入推销代码和条形码值之一。",
    CHECK_EVENT_PRIZE_PERCENT_OVER_100: "请指定商品的概率合计为100以下。",
    CHECK_EVENT_REGISTERED: "请先注册您的活动。",
    CHECK_ONLY_NUMBER: "只能输入数字。",
    EVENT_CREATE_ERROR: "在同一产品中注册了另一个事件，且事件周期重叠。",

    CHECK_EVENT_COMPANY: "请选择合作公司",
    CHECK_EVENT_PRODUCT: "请选择产品。",
    CHECK_PRODUCT_REGISTERED: "请先登记产品。",
    COPY_TO_CLIPBOARD: "已复制到夹板上。",

    CHECK_PERSONAL_INFO_AGREE:
      "Please agree to offer your personal information China",

    EVENT_WRONG_ACCESS_MESSAGE: "Wrong Access China",
    EVENT_NOT_EXISTS: "No Event China",
    EVENT_EXPIRED: "This event is expired China",
    LOTTO_VOID_MESSAGE: "다음 기회에",

    FEED_NOT_CHECKED: "Please select the answer China",
    FEED_ETC_NOT_EXIST: "Please input the answer China",
    FEED_SUBMITTED: "Your survey has been submitted China",
    FEED_SUBMITTED2: "Thank you for your feedback China.",

    /////// 유통자 //////////

    TAKE_OVER_COMPLETE: "Take-over is complete China",
    HAND_OVER_COMPLETE: "Hand-over is complete China",

    /////// 관리자 //////////
    PRODUCT_IMAGE_LIMIT_EXCEED: "Images can be registered up to 10 China",
    CONFIRM_SEND_MESSAGE: "确定要发送信息吗?",

    ///// 관리자 추가된 항목들 ////
    CHECK_EA_RANGE: "请输入0到1,000,000之间的数量。",
    CHECK_EA_ALERT:
      "在较低级别发布的代码数量不能大于在较高级别接受的代码数量。",
    CODE_CREATE_PROCESSING: "正在发布代码请稍后再试。",
    CODE_CREATE_COMPLETED: "代码发布完成。",
    ISSUE_CODE_FIRST: "没有发出代码。请首先发布代码。",
    PRODUCT_CODE_ORDER_LIMITTED: "产品序列号只能在0到99之间分配。",

    PRODUCT_CREATE_PROCESSING: "注册您的产品。请稍后再试。",
    PRODUCT_CREATE_COMPLETED: "产品已注册。",
    URL_REQUIRED: "磁铁认证指南已开启。请输入要链接的URL。",

    EVENT_CREATE_COMPLETED: "该事件已被注册。",
    NUMBER_ONLY: "概率/项目数量只能输入数字。",

    SELECT_DISTRIBUTOR_CODE: "请选择一个代码",
    SELECT_DISTRIBUTORS: "请指定至少一位经销商。",
    SELECT_DISTRIBUTORS_COMPLETED: "分销商分配已完成。",
    SELECT_DISTRIBUTORS_REMOVED: "发行人已被删除。",

    POST_CODE_LENGTH: "请输入10个字符以内的邮政编码",
    COMPANY_ID_LENGTH: "请输入至少5个字符。",

    USER_DUPLICATED: "该电子邮件已被注册。",
    COMPANY_CREATE_COMPLETED: "会员已注册。",
    DISTRIBUTOR_CREATE_COMPLETED: "发行人已注册。",
    ADMIN_CREATE_COMPLETED: "管理员已注册。",

    PARAM_ERROR: "缺少所需的值。",
    INVALID_PARAM: "缺少所需的值。",
    STATUS_UPDATED: "状态已经改变。",
    UPDATE_COMPLETED: "信息已更新。",
    CREATE_COMPLETED: "该信息已保存。",
    ////////////

    UNKNOWN_ERROR: "未知的网络错误。",

    CONFIRM_OVER_10000: "超出认证范围。",
    ACTION_DUPLICATED:
      "The previously requested takeover & delete operation has not been completed. Please wait.",

    //MSG_ 로 시작하는 에러코드는 유저에게 이유를 출력해줘야 한다.
    MSG_MUST_DO_HANDOVER_FIRST:
      "This product / box code has not yet been handed over.", //아직 인계가 안된 제품/박스 CODE입니다.
    MSG_THIS_CODE_CAN_NOT_TAKE_OVER:
      "It is not your own code that can be acquired.", // 내가 인수 할 수있는 CODE가 아닙니다. 남의 소유.
    MSG_THIS_CODE_WAS_TAKE_OVER: "Code is already taken over", //벌써 인계된 코드입니다.
    MSG_CODE_IS_NOT_TAKE_OVER: "Code that you did not take.", //자신이 인수한 CODE가 아닙니다.
    MSG_CODE_IS_NOT_HAND_OVER: "It is not a code that you can take over.", //자신이 인계할 수 있는 CODE가 아닙니다.
    MSG_EXCEL_CODE_DATA_IS_INVALID: "It is not a well-formed Excel file.", // 수동 업로드되는 엑셀파일 포맷에 오류가 있습니다.
    MSG_CODE_IS_NOT_MINE: "You are not in charge of this code.", // 이 CODE의 담당자가 아닙니다.
    MSG_PRODUCT_CAN_NOT_CONFIRMED: "The item cannot be authenticated.", // 상품을 인증할 수 없습니다.
    MSG_CODE_IS_NOT_TAKE_OVER1: "您可以接管的不是您自己的代码。",
    MSG_CODE_IS_NOT_HAND_OVER1: "QR码产品或公司类型不同。",
    MSG_CODE_IS_NOT_HAND_OVER2: "它不是同一家公司的产品。",

    //서버에서 오는게 아닌 클라이언트에서 자체적으로 띄워주는 에러 메시지, MSG가 붙지 않는다 0916
    NO_PRODUCT_CODE_CONFIRMED:
      "You have not received an authorization code to compare.",
    INPUT_PRODUCT_CODE: "Please enter the authorization code.",
    NOT_PROVIDED_PRODUCT_CODE: "Authorization codes do not match",

    // 로그인
    AUTHENTICATION_INVALID: "此帐户已禁用。",
    USER_MISMATCH: "아이디 혹은 비밀번호를 확인해주세요.",
    PASSWORD_MISMATCH: "잘못된 비밀번호 입니다."
  }
};

export const FACEBOOK = {
  // appId: "661474037663070",
  // client_secret: "3cd35ee25f314137c6339579df8b8feb",
  // app_token: "661474037663070|nYcPjbpV7tyerVHQ-V_WA4ZWq04"
  appId: "591938726219696",
  client_secret: "d95621e3ad1131aeae70a1dfa0897cbd",
  app_token: "591938726219696|I11smluuSHSFpogG7SCRuN3N60s"
};

export const LINE = {
  client_id: "1660905267",
  client_secret: "6d31ef7856862ba091d776e7bba44f04"
};

export const WEIBO = {
  client_id: "2036326890",
  client_secret: "8752f4402aae8821047c4d1a8ddf89ea"
};

export const GOOGLE_MAP = {
  apiKey: "AIzaSyBM-Z22ZnKvV5kc-Gm8D3zPPD6YuLduU48"
};

export const GEOCODE = {
  apiKey: "AIzaSyD0n0gL20rJicY7IgAiZFNkqiXGazGeP7A"
};

export const TOKEN = {
  admin: "mCHeckToken",
  distributor: "nb-distributor-token",
  company: "nb-company-token",
  user: "nb-user-token"
};

export const LOGIN_TIME = {
  admin: "ADMIN_LOGIN_TIME",
  distributor: "DISTRIBUTOR_LOGIN_TIME",
  company: "COMPANY_LOGIN_TIME",
  user: "USER_LOGIN_TIME"
};

export const ADMIN_TYPE = "ADMIN_TYPE";

export const LOGIN_SESSION = "nb-login-account";

export const NB_LOGIN_TYPE = {
  Admin: "admin",
  Company: "company",
  Distributor: "distributor",
  User: "user"
};

export const CALL_SCAN_HAND_OVER = 1;
export const CALL_SCAN_TAKE_OVER = 2;
export const CALL_SCAN_PRODUCT_CONFIRM = 3;
export const CALL_SCAN_MOVE = 4;
export const CALL_SCAN_ADD = 5;
export const CALL_SCAN_REMOVE = 6;

export const EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const getSession = () => {
  return window.localStorage.getItem(LOGIN_SESSION);
};

export const getCountryCode = () => {
  try {
    let env = checkDevice();

    let countryCode = "en";

    if (env == "android") {
      countryCode = window.android.getCountryCode();
    } else if (env == "web") {
      const navigatorLang = navigator.language;
      if (navigatorLang.indexOf("ko") > -1) {
        countryCode = "kr";
      } else if (navigatorLang.indexOf("en") > -1) {
        countryCode = "en";
      } else if (navigatorLang.indexOf("zh") > -1) {
        countryCode = "cn";
      } else {
        countryCode = "en";
      }
    }

    const countryCodeTable = {
      kr: ["kr"],
      cn: ["cn", "tw", "hk"]
    };

    let currentCountryCode =
      Object.keys(countryCodeTable).find(key => {
        return countryCodeTable[key].indexOf(countryCode) > -1;
      }) || "en";

    return currentCountryCode;
  } catch (e) {
    console.log(e);
  }
};

const CONFIRM_CLIENT_ID_STORAGE_KEY = "nb-confirm-client-id";

export const getConfirmClientId = () => {
  if (typeof window === "undefined") return null;
  if (window.__nbConfirmClientId) return window.__nbConfirmClientId;

  try {
    let clientId = window.localStorage.getItem(CONFIRM_CLIENT_ID_STORAGE_KEY);
    if (!clientId) {
      clientId = uuidv1();
      window.localStorage.setItem(CONFIRM_CLIENT_ID_STORAGE_KEY, clientId);
    }
    window.__nbConfirmClientId = clientId;
    return clientId;
  } catch (e) {
    return null;
  }
};

export const getUUID = () => {
  try {
    let env = checkDevice();
    let uuid = null;
    let uuidSource = null;
    const storageKey = "nb-device-uuid";
    const getStorageUUID = sourcePrefix => {
      let storageUUID = null;
      try {
        storageUUID = window.localStorage.getItem(storageKey);
        if (!storageUUID) {
          storageUUID = uuidv1();
          window.localStorage.setItem(storageKey, storageUUID);
          uuidSource = sourcePrefix + "_new";
        } else {
          uuidSource = sourcePrefix + "_existing";
        }
      } catch (storageError) {
        storageUUID = uuidv1();
        uuidSource = sourcePrefix + "_storage_error";
      }
      return storageUUID;
    };

    if (
      env == "android" &&
      window.android &&
      typeof window.android.getUUID === "function"
    ) {
      uuid = window.android.getUUID();
      uuidSource = uuid ? "android_native" : "android_native_empty";
      if (!uuid) uuid = getStorageUUID("android_storage_fallback");
    } else {
      uuid = getStorageUUID(env == "android" ? "android_bridge_missing" : "web");
    }

    window.__nbLastUUIDSource = uuidSource;
    getConfirmClientId();
    console.log(uuid);

    return uuid;
  } catch (e) {
    window.__nbLastUUIDSource = "uuid_error";
    console.log(e);
  }
};

export const getUrlPathname = (path, length) => {
  const pathItem = path.split("/");

  if (pathItem.length < 2 || length < 1) {
    return path;
  }

  return pathItem
    .filter((item, i) => {
      return i <= length;
    })
    .map(item => {
      return item;
    })
    .join("/");
};

export const isJSON = str => {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
};

export const getUrlByEnv = () => {
  const apiUrls = {
    production: "https://live-api.mcheckplus.com/api/v1",
    development: "https://test-api.mcheckplus.com/api/v1"
  };
  const env = apiUrls["production"]; // apiUrls[process.env.NODE_ENV] || apiUrls['development'];

  return env;
};

export const errorTableKr = {
  PARAM_ERROR: 400,

  AUTHENTICATION_REQUIRED: "접근 권한이 없습니다.", //권한 없음
  AUTHENTICATION_INVALID: 401,
  TOKEN_INVALID: 401,
  TOKEN_EXPIRED: 401,
  UNAUTHORIZED: 401,
  ALREADY_REPEATED_ACTION: "중복된 요청입니다.", //중복된 요청.
  FORBIDDEN: "요청이 거부되었습니다. 잠시후 다시 시도해주세요.", // 요청이 거부됨. 잠시후 다시 시도해주세요.
  USER_NOT_FOUND: "존재하지 않는 유저입니다.", //찾을 수 없음
  API_NOT_FOUND: 404,
  DATA_NOT_FOUND: "요청한 데이타를 찾을 수 없습니다.", //요청한 데이타를 못찾음.
  DATE_EXPIRE: "유효기간이 만료 되었습니다.", //유효한 기간 아님( 인증기간 만료.)
  USER_DUPLICATED: 409, //충돌
  NICK_DUPLICATED: 409, //충돌
  EMAIL_DUPLICATED: 409,
  PRODUCT_AUTH_DENIED: "등록되지 않은 제품입니다.",
  PRODUCT_AUTH_WRONG: "인증오류",
  PRODUCT_AUTH_EXPIRED: "인증 만료 제품입니다.",
  USER_MISMATCH: "아이디 혹은 비밀번호를 확인해주세요.",
  PASSWORD_MISMATCH: "잘못된 비밀번호 입니다.",
  TOKEN_MISMATCH: 409,
  REQUIRED_PARAM: 422,
  INVALID_PARAM: 422,
  INVALID_DATA: 422,
  SERVER_IS_MAINTENANCE: "서버 점검중 입니다. 잠시만 기다려주세요.", //서버점검중입니다. 잠시만 기다려주세요.

  //MSG_ 로 시작하는 에러코드는 유저에게 이유를 출력해줘야 한다.
  MSG_MUST_DO_HANDOVER_FIRST: "아직 인계가 되지않은 제품/박스 코드입니다.", //아직 인계가 안된 제품/박스 CODE입니다.
  MSG_THIS_CODE_CAN_NOT_TAKE_OVER: "자신이 인수 가능한 코드가 아닙니다.", // 내가 인수 할 수있는 CODE가 아닙니다. 남의 소유.
  MSG_THIS_CODE_WAS_TAKE_OVER: "이미 인계된 코드입니다.", //벌써 인계된 코드입니다.
  MSG_CODE_IS_NOT_TAKE_OVER: "자신이 인수 하지않은 코드입니다.", //자신이 인수한 CODE가 아닙니다.
  MSG_CODE_IS_NOT_HAND_OVER: "자신이 인계 가능한 코드가 아닙니다.", //자신이 인계할 수 있는 CODE가 아닙니다.
  MSG_EXCEL_CODE_DATA_IS_INVALID: "올바른 형식의 엑셀파일이 아닙니다.", // 수동 업로드되는 엑셀파일 포맷에 오류가 있습니다.
  MSG_CODE_IS_NOT_MINE: "이 코드의 담당자가 아닙니다.", // 이 CODE의 담당자가 아닙니다.
  MSG_PRODUCT_CAN_NOT_CONFIRMED: "상품을 인증 할 수 없습니다.", // 상품을 인증할 수 없습니다.

  //서버에서 오는게 아닌 클라이언트에서 자체적으로 띄워주는 에러 메시지, MSG가 붙지 않는다 0916
  NO_PRODUCT_CODE_CONFIRMED: "비교할 승인 코드를 받아오지 않았습니다",
  INPUT_PRODUCT_CODE: "승인 코드를 입력해주세요.",
  NOT_PROVIDED_PRODUCT_CODE: "승인 코드가 일치하지 않습니다"
};

export const getError = (data, locale) => {
  let error = data.error;

  if (!error || !error.code) {
    return {
      errorMessage:
        locale && MESSAGE_TABLE[locale]
          ? MESSAGE_TABLE[locale]["UNKNOWN_ERROR"]
          : MESSAGE_TABLE["en"]["UNKNOWN_ERROR"]
    };
  }
  data.code = error.code;

  // 수정필요: 언어별로 에러메시지 출력
  data.errorMessage = errorTableKr[error.code] || "네트워크 에러입니다.";

  return data;
};

// files => { logoUrl: ~~~, imageUrl: ~~~ } 같은 키밸류로 이루어진 파라미터
export const uploadFiles = files => {
  try {
    const fileKeys = Object.keys(files);
    const fileValues = Object.values(files);
    return action.eFILE.uploadFile(fileValues).then(fileUrls => {
      const result = {};
      for (let fileUrl of fileUrls) {
        let index = fileUrls.indexOf(fileUrl);

        result[fileKeys[index]] = fileUrl.original;
      }
      return result;
    });
  } catch (e) {
    return e;
  }
};

// 소비자 앱 화면 닫기
export const userAppCloseActivity = () => {
  try {
    let env = checkDevice();

    if (env == "android") {
      window.android.closeActivity();
    } else if (env == "ios") {
      window.webkit.messageHandlers.iosHandler.postMessage({
        functionName: "closeActivity"
      });
    } else {
      console.log("Not Device");
    }
  } catch (e) {
    console.log(e);
  }
};

// 유통자앱 스캔 화면 호출
export const callScan = (isBox, action) => {
  try {
    let env = checkDevice();

    if (env == "android") {
      window.android.callScan(isBox, action);
    } else if (env == "ios") {
      window.webkit.messageHandlers.iosHandler.postMessage({
        param: setIOSParameter({ isBox: isBox, action: action }),
        functionName: "callScan"
      });
    } else {
      console.log("Not Device");
    }
  } catch (e) {
    console.log(e);
  }
};

// 아이폰 용 외부 링크 호출 브릿지
export const goLinkInIOS = link => {
  try {
    let env = checkDevice();

    if (env == "ios") {
      window.webkit.messageHandlers.iosHandler.postMessage({
        param: setIOSParameter({ link: link }),
        functionName: "goLink"
      });
    }
  } catch (e) {
    console.log(e);
  }
};

// 앱 경고창 띄우기
export const showAlert = (title, message) => {
  try {
    let env = checkDevice();

    if (env == "android") {
      window.android.showAlert(title, message);
    } else if (env == "ios") {
      window.webkit.messageHandlers.iosHandler.postMessage({
        param: setIOSParameter({ title: title, message: message }),
        functionName: "showAlert"
      });
    } else {
      window.alert(message);
    }
  } catch (e) {
    console.log(e);
  }
};

// 앱에서 로그인 성공 시
export const onLoginSuccess = (token, uid) => {
  try {
    let env = checkDevice();

    if (env == "android") {
      window.android.onLoginSuccess(token, uid);
    } else if (env == "ios") {
      window.webkit.messageHandlers.iosHandler.postMessage({
        param: setIOSParameter({ token: token, uid: uid }),
        functionName: "onLoginSuccess"
      });
    } else {
      console.log("Not Device");
    }
  } catch (e) {
    console.log(e);
  }
};

export const doFacebookLogin = () => {
  try {
    let env = checkDevice();
    console.log(env);
    window.android.fbLoginCallback();
  } catch (e) {
    console.error(e);
  }
};

// 유통앱에서 인수(인계) 완료 하고 화면 닫을때 씀
export const completeProcess = (token, uid) => {
  try {
    let env = checkDevice();

    if (env == "android") {
      window.android.completeProcess();
    } else if (env == "ios") {
      window.webkit.messageHandlers.iosHandler.postMessage({
        functionName: "completeProcess"
      });
    } else {
      console.log("Not Device");
    }
  } catch (e) {
    console.log(e);
  }
};

// 사용 장치 체크
export const checkDevice = () => {
  try {
    let env = "web";
    if (window.android) {
      console.log("Android Device");
      env = "android";
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.iosHandler
    ) {
      console.log("IOS Device");
      env = "ios";
    }

    return env;
  } catch (e) {}
};

// 문자열 관련
// url 관련

export const parseUrlParameter = search => {
  let vars = search.substr(1).split("&");
  let queryString = {};
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    // If first entry with this name
    if (typeof queryString[pair[0]] === "undefined") {
      queryString[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
    } else if (typeof queryString[pair[0]] === "string") {
      let arr = [queryString[pair[0]], decodeURIComponent(pair[1])];
      queryString[pair[0]] = arr;
      // If third or later entry with this name
    } else {
      queryString[pair[0]].push(decodeURIComponent(pair[1]));
    }
  }
  return queryString;
};

// url의 pathname을 파싱해서 배열로 돌려준다
export const parsePathname = pathname => {
  return pathname.split("/");
};

// 문자열 관련
export const getNextLine = str => {
  return str.split("\n").map(line => {
    return line;
  });
};

// 로컬스토리지 만료 함수
export const compareLocalStorageTime = () => {
  const tokens = TOKEN;
  const loginTime = LOGIN_TIME;

  for (let key of Object.keys(tokens)) {
    let time = localStorage.getItem(loginTime[key]);

    if (
      !time ||
      !isValidDate(new Date(time)) ||
      moment
        .duration(moment(new Date()).diff(moment(new Date(time))))
        .asDays() >= 1
    ) {
      localStorage.removeItem(tokens[key]);
      localStorage.removeItem(loginTime[key]);
    }
  }
};

// 앱 단에서 로그아웃 됐는지 확인하는 함수
export const checkAppAccessToken = url => {
  const tokens = TOKEN;
  const loginTime = LOGIN_TIME;
  console.log("check access token called");
  let appToken = "";

  let env = checkDevice();

  if (env == "android") {
    try {
        appToken = window.android.getAccessToken();
    } catch (e) {
        console.error(e);
    }
  } else if (env == "ios") {
    try {
        window.webkit.messageHandlers.iosHandler.postMessage({
            functionName: "getAccessToken"
        });
    } catch (e) {
        console.error(e);
    }
  } else {
    return;
  }

  if (!appToken) {
    for (let key of Object.keys(tokens)) {
      try {
        localStorage.removeItem(tokens[key]);
        localStorage.removeItem(loginTime[key]);
      } catch (e) {
        console.error(e);
      }
    }
  }
};

//// 날짜 관련

export const isValidDate = date => {
  return (
    date &&
    Object.prototype.toString.call(date) === "[object Date]" &&
    !isNaN(date)
  );
};

export const convertToTimezone = date => {
  let t = new Date(date);

  return isValidDate(t)
    ? new Date(t.getTime() + t.getTimezoneOffset() * 60000).toISOString()
    : date;
};

export const getDateFormat = (fmt, date) => {
  // moment.locale( 'en' );
  switch (fmt) {
    case "llll":
      return moment(date).format("llll");
    case "ll":
      return moment(date).format("ll");
    case "LT":
      return moment(date).format("LT");
    case "fromNow":
      return moment(date).fromNow();
    case "point":
      return moment(date).format("YYYY.MM.DD");
    case "number":
      return moment(date).format("YYMMDD");
    case "dash":
      return moment(date).format("YYYY-MM-DD");
    case "kor":
      return moment(date).format("DD일, dd요일");
    case "custom":
      return moment(date).format("YYYY년 M월 D일, a HH:mm");
    default:
      return moment(date).format(fmt);
  }
};

export const addDays = (date, num, fmt) => {
  if (!date || !num) {
    console.log("No Date or Number");
    return;
  }

  let addedDate = moment(date).add(num, "day");

  return fmt ? moment(addedDate).format(fmt) : new Date(addedDate);
};

export const getTimeStampToDateFormat = (fmt, timestamp) => {
  return moment(timestamp).format(fmt);
};

// { key: value, key: value,... } 형태로 파라미터를 받으면 문자열로 파싱해줌
export const setIOSParameter = params => {
  let paramString = (Object.keys(params) || []).map(key => {
    return key + ":" + params[key];
  });

  return paramString.join(",");
};

// 이미지 관련

// 관리자 input 값 validation 함수
// 필수값을 체크한 후 통과하면 null, 빠진 값이 있으면 언어별 메시지를 반환한다.
// value는 object로 된 기준값
// required의 형태는 { field: 'krName', krName: '한국어명', enName: 'korean name', cnName: '韩语名', .... }, 의 배열값
export const checkValidation = ({ value, requiredList, locale, ...props }) => {
  let valueName = { kr: "", en: "", cn: "" };
  console.log(props);
  if (props.valueName == "company") {
    valueName.kr = "제휴사";
    valueName.en = "company";
    valueName.cn = "公司";
  } else if (props.valueName == "distributor") {
    valueName.kr = "유통자";
    valueName.en = "distributor";
    valueName.cn = "流通者";
  } else if (props.valueName == "product") {
    valueName.kr = "제품";
    valueName.en = "product";
    valueName.cn = "产品";
  } else if (props.valueName == "event") {
    valueName.kr = "이벤트";
    valueName.en = "event";
    valueName.cn = "活动";
  } else if (props.valueName == "admin") {
    valueName.kr = "ADMIN";
    valueName.en = "ADMIN";
    valueName.cn = "ADMIN";
  }

  for (let required of requiredList) {
    if (required) {
      let fieldKeys = required.field.split(".");

      let realValue;

      if (fieldKeys.length > 1) {
        realValue = fieldKeys.reduce((a, b) => {
          console.log(a, b);
          if (typeof a === "String") {
            return value[a];
          } else {
            return value[a][b];
          }
        });
      } else {
        realValue = value[fieldKeys[0]];
      }
      console.log("function ", realValue);
      console.log("function ", fieldKeys);

      // 함수를 통과하지 못하면 alert창을 띄워줍니다.
      if (required.func) {
        if (required.funcMessage && !required.func(realValue)) {
          // 함수에 할당된 alert 메시지가 지정된 경우 함수를 통과하지 못했을때 해당 메시지를 반환합니다.
          return MESSAGE_TABLE[locale][required.funcMessage];
        } else if (!required.funcMessage && required.func(realValue)) {
          // 함수에 할당된 alert 메시지가 없을 떄는 함수의 반환값(메시지)을 반환합니다. 반환값이 있으면 validation 통과 실패한 걸로 간주 (별도의 alert메시지가 필요할때)
          return required.func(realValue);
        }
      } else if (!realValue) {
        let messageTable = {
          kr: value => {
            return valueName.kr + "의 " + value + "을(를) 입력해주세요.";
          },
          en: value => {
            return "Please input " + value + " of " + valueName.en;
          },
          cn: value => {
            return "请输入" + valueName.cn + "的" + value;
          }
        };
        console.log("이미지 누락");
        console.log(required.funcMessage);
        return required.funcMessage
          ? MESSAGE_TABLE[locale][required.funcMessage]
          : messageTable[locale](required[locale + "Name"]);
      }
    }
  }

  return null;
};

export const getImageNameFromUrl = url => {
  return url ? url.substring(url.lastIndexOf("/") + 1, url.length) : url;
};
